import { SDK } from '@redge-media/fo-js-sdk';
import { HeaderName } from '@/shared/enums';
import { generateCookie } from './bookmark-cookie';

export default {
  destroy(records, opts = {}) {
    const method = 'del';
    const sync = () => {
      records.forEach((r) => this.collection.remove(r.id));
      return this.emit('sync', method, this);
    };

    return SDK.apiAdapter[method](this.endpoint, {
      headers: {
        [HeaderName.STATS_HASH]: this.subscriber.externalStatsHash,
      },
      params: {
        itemId: records.map((record) => record.id),
        token: this.subscriber.profile.token,
        profileId: this.subscriber.profile.id,
      },
    }).then(() => {
      generateCookie({
        id: this.subscriber.id,
        name: this.cookieName,
        time: this.time.now,
      });

      if (!opts.refresh) {
        return Promise.resolve(sync());
      }

      return this.fetchAll('', { reset: true });
    });
  },
};
